import { createFileRoute } from "@tanstack/react-router";
import { UploadLaadsessies } from "~/components/upload-laadsessies";

export const Route = createFileRoute("/(authenticated)/upload-laadsessies/")({
  component: UploadLaadsessies,
});
